import React from 'react';
import { graphql } from 'gatsby';
import { PageListing as PageListingComponent } from '../../../pageListing/PageListing';

export const PageListing = ({ data, ...rest }) => (
  <PageListingComponent {...data} {...rest} />
);

export const PageListingQuery = graphql`
  fragment PageListing on UMBRACO_PageListingComponentType {
    childPages {
      name
      url
      ... on UMBRACO_PageType {
        properties {
          feed {
            shortDescription
            shortTitle
            featuredImage {
              image {
                ...PageListingImage
              }
            }
          }
        }
      }
    }
  }
`;
